__turbopack_context__.v({
  "clientLogo": "styles-module-scss-module__ykmesW__clientLogo",
  "marquee": "styles-module-scss-module__ykmesW__marquee",
  "marqueeItem": "styles-module-scss-module__ykmesW__marqueeItem",
});
